/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-06-29 16:38:29
 * @LastEditors: kai.zhou
 * @LastEditTime: 2021-04-25 20:37:00
 */
export default {
  lang: "阿拉伯语",
  landing: {
    name1: "افتح تطبيق كارلكير",
    name2: "إجراء حجز",
    name3: "افتح تطبيق كارلكير .. يمكنك ",
    name4: " التحقق معلومات الطلب في أي وقت!",
  },
};